import { render, staticRenderFns } from "./DialogProcedimentoSearch.vue?vue&type=template&id=84f8d5ea&scoped=true"
import script from "./DialogProcedimentoSearch.vue?vue&type=script&lang=ts"
export * from "./DialogProcedimentoSearch.vue?vue&type=script&lang=ts"
import style0 from "./DialogProcedimentoSearch.vue?vue&type=style&index=0&id=84f8d5ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84f8d5ea",
  null
  
)

export default component.exports